<template>
  <div>
    <b-navbar
      type="dark"
      fixed="top"
      variant="info"
      class="navbar"
    >
      <b-navbar-brand>蝴蝶蘭分級系統</b-navbar-brand>
      <b-collapse
        id="nav-text-collapse"
        is-nav
      >
        <b-navbar-nav>
          <b-nav-item :href="rootUrl">
            首頁
          </b-nav-item>
          <b-nav-item v-b-modal.model-standard>
            分級標準表
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-modal
      id="model-standard"
      ok-only
      size="xl"
      hide-footer
      ok-title="關閉"
      :scrollable="true"
    >
      <template v-slot:modal-title>
        蝴蝶蘭盆花品質影像分級標準表
      </template>
      <StandardTable />
    </b-modal>
    <Home class="flower_container" />
  </div>
</template>

<script>
// component
  import Home from './views/Home.vue';
  import StandardTable from './components/StandardTable.vue';

  export default {
    name: 'App',
    components: {
      Home,
      StandardTable,
    },
    data() {
      return {
        rootUrl: '/',
      };
    },
    created() {
      this.rootUrl = this.rootUrl + window.location.search;
    },
  };
</script>

<style scoped>
  .flower_container {
    margin-top: 80px;
  }
</style>
